var _style, _g, _circle, _circle2, _circle3, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLostinspaceDinoStatic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 131.4 119.2",
    style: {
      enableBackground: "new 0 0 131.4 119.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0{fill:#E8F2F9;}\n  .st1{fill:#005D9A;}\n  .st2{fill:none;stroke:#005D9A;stroke-width:2;stroke-miterlimit:10;}\n  .st3{fill:none;}\n  .st4{fill:#E8F2F9;stroke:#005D9A;stroke-width:3;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lostinspaceDinoStatic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    className: "st0",
    d: "M71.4,117.2c31.5,0,57-25.5,57-57s-25.5-57-57-57c-39.2,0-57,34.6-57,57     C14.4,91.7,39.9,117.2,71.4,117.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st1",
    d: "M20.8,91c-3.9-7.1-6.5-18.1-6.6-27.4C13.9,47,20.3,31.1,31.8,19.2l2.2,2.1     C23,32.6,17,47.8,17.2,63.5c0.1,8.9,2.6,19.3,6.3,26.1L20.8,91z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    className: "st1",
    d: "M72.7,119.2c-12,0-23.6-3.7-33.4-10.6l1.7-2.5c25.2,17.4,59.8,11.1,77.2-14.1     c17.3-25,11.3-59.2-13.5-76.8l1.7-2.5c12.7,8.9,21.4,22.5,24.1,37.8c2.7,15.3-0.7,31-9.7,43.7c-8.9,12.7-22.5,21.4-37.8,24.1     C79.6,118.9,76.2,119.2,72.7,119.2z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 47.8,
    cy: 30.7,
    r: 2.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 109.6,
    cy: 82.5,
    r: 2.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 59.2,
    cy: 103.8,
    r: 1.7
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "planet"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.2,22.2C70.7,28.4,60.4,40,55.3,36.4c-7.5-9.2,23.6-38.1,32.3-36C95.4,4.7,77.2,22.2,77.2,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.6,8.1c-1.7,2.8-3.6,5.5-5.8,7.9c-3.3,3.9-7,7.5-11.1,10.6c-0.9,0.7-2,1.3-2.9,2c-0.2,0.2-0.5,0.2-0.7,0     c0,0,0,0-0.1-0.1c-5.1-5.2-5.6-13.4-1-19.1c5.1-6.2,14.3-7.2,20.6-2.2l0.6,0.5L81.6,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.4,27.4c0.7,1,1.4,1.9,2,2.8c0.1,0.2,0.1,0.3,0,0.5c-0.2,0.6-0.4,1.2-0.6,1.9c-0.3,1.1,0.1,1.5,1.3,1.4     c1.2-0.2,2.3-0.6,3.3-1.2c3.1-1.8,6.1-4,8.8-6.5c5.6-4.9,10.4-10.6,14.4-16.9c0.6-1,1.2-2.1,1.6-3.1c0.2-0.6,0.4-1.1,0.4-1.8     c0.1-0.5-0.2-1.1-0.7-1.2c-0.2,0-0.3,0-0.5,0c-0.8,0.2-1.5,0.5-2.3,0.7c-0.2,0-0.4,0.2-0.8,0.3C80.9,4,79.4,3.8,78,3.6     c1.8-0.9,5.4-3.5,7.5-3.6c2.6-0.1,4.4,1.6,4.1,4.7c-0.2,1.6-0.7,3.2-1.5,4.6s-1.6,2.8-2.4,4.2c-0.1,0.3-0.2,0.5-0.1,0.8     c0.9,3.2,0.8,6.5-0.4,9.6c-1.8,4.7-6,8.1-11,8.9c-2,0.3-4,0.2-6-0.3c-0.3-0.1-0.5,0-0.8,0.2c-2.2,1.7-4.6,3-7.2,4     c-1,0.4-2.1,0.5-3.2,0.4c-1.4-0.1-2.5-1.2-2.8-2.5c-0.2-0.9-0.3-1.9-0.1-2.8C54.2,30.3,54.7,28.8,55.4,27.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "dino"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M83,73.9c4.3,4.3,7.9,8.4,3.8,10.7s-9.5-5.3-9.3-5.5S83,73.9,83,73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48.9,84.8c0,0-3.4,3.8-5.6,6.2c-0.8,0.9-0.9,2.2-0.3,3.2c3.4,5.9-2.4,7.9-4,6.6c-1.3-1.1-5.5-5.2-7.6-7.4     c-0.8-0.8-0.9-2-0.4-2.9L37.3,79L48.9,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.4,43.5C5.5,43.2,6,43.3,6,43.6c1.6,8.2,7.8,21.3,19.7,12.2c12.1-9.1,16.9-27.6,43.6-3.7     c1.3,1.2,3.3,1.4,4.8,0.5c9-5.4,3.4-17,18.5-18.7c6.7-0.8,12.5,7.5,14.4,12.6c0.1,0.4,0.4,0.7,0.7,0.9     c15.8,12.4,2.7,27.8-15.1,15.4c-0.3-0.2-0.7-0.2-0.9,0.1C87,69.4,80.2,78.4,74.3,81.2c-0.3,0.1-0.3,0.4-0.2,0.7     c2.8,3.4,9.1,13.7,3.4,15.7c-6,2-10.6-11.6-13.7-12.5c-3.1-0.8-9.5,6.2-29.5-8c-0.5-0.4-1.2-0.4-1.8-0.1c-3.9,2-8.7,3.4-9.5,5.1     c-0.9,1.8,5.4,6.2,1.1,9S8.6,80.4,8.6,79.2c0-1,6.7-5.1,9.4-6.8c0.4-0.3,0.3-0.9-0.1-1C12.9,69.9-5.1,63,5.4,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.2,54.7c-3.8,0-6.8-3-6.8-6.8s3-6.8,6.8-6.8s6.8,3,6.8,6.8l0,0C101,51.7,97.9,54.7,94.2,54.7z M94.2,44     c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S96.4,44,94.2,44z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 94.2,
    cy: 47.9,
    r: 2.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLostinspaceDinoStatic);
export default __webpack_public_path__ + "static/media/lostinspaceDinoStatic.1da532cf.svg";
export { ForwardRef as ReactComponent };